import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  ChangeDetectorRef,
  HostListener
} from '@angular/core';
import { PhotoGalleryService } from '@shared/services/photo-gallery/photo-gallery.service';
import { PhotoCarouselService } from '@shared/services/photo-carousel/photo-carousel.service';
import { NgbCarousel } from '@ng-bootstrap/ng-bootstrap';
import { ViewportService } from '@shared/services/viewport/viewport.service';

@Component({
  selector: 'photo-gallery',
  templateUrl: './photo-gallery.component.html',
  styleUrls: ['./photo-gallery.component.scss']
})
export class PhotoGalleryComponent implements OnInit, AfterViewInit {
  @ViewChild('imageCarousel')
  imageCarousel: NgbCarousel;

  images = [];
  previewImage;
  triggerOnSlide = false;
  imageIndex;
  thumbnailHeight = `80px`;
  thumbnailHeightWrapper = `86px`;
  showThumbnails;
  isDesktop;
  isTablet;
  isMobile;
  hideText;
  slideWidth = '100%';
  slideHeight = '60vh';

  @HostListener('window:resize', ['$event'])
  onResize() {
    setTimeout(() => {
      this._viewportService.checkViewSizes();
      this.updateThumbnailHeight();
      this.changeDetectorRef.detectChanges();
    }, 250);
  }
  constructor(
    private _photoGalleryService: PhotoGalleryService,
    private changeDetectorRef: ChangeDetectorRef,
    private _photoCarouselService: PhotoCarouselService,
    private _viewportService: ViewportService
  ) {
    this._viewportService.updatingView.subscribe(() => {
      this.isDesktop = this._viewportService.isDesktop();
      this.isTablet = this._viewportService.isTablet();
      this.isMobile = this._viewportService.isMobile();
    });
  }

  ngOnInit() {
    this._photoGalleryService.images.subscribe(images => {
      this.images = images;
      this.previewImage = this.images.length > 0 && this.images[0];
    });

    this._photoGalleryService.showThumbnails.subscribe(showThumbnails => {
      const isShowThumbnails = showThumbnails;
      this.showThumbnails = isShowThumbnails;
      if (isShowThumbnails) {
        this.hideText = true;
      } else {
        this.hideText = false;
      }
    });

    this._photoGalleryService.slideId.subscribe(id => {
      this.imageIndex = id || 0;
      this.previewImage =
        this.images.length > 0 && this.images[this.imageIndex];
    });

    this._photoCarouselService.updateImageIndex.subscribe(index => {
      this.imageIndex = index;
      this.previewImage =
        this.images.length > 0 && this.images[this.imageIndex];
    });

    this._viewportService.checkViewSizes();
  }

  ngAfterViewInit() {
    this.updateThumbnailHeight();
    this.changeDetectorRef.detectChanges();
  }

  closeImageGallery() {
    this._photoGalleryService.toggle();
  }

  selectPreviewImage(image) {
    if (this.isMobile) {
      this.showThumbnails = false;
    }
    this.imageIndex = image.slideId;
    this.triggerOnSlide = false;
    this._photoCarouselService.setImageIndex(this.imageIndex);
  }

  updateThumbnailHeight() {
    const thumbnailWidth = document.querySelector('.thumbnail-photo');
    this.thumbnailHeight = `${thumbnailWidth.clientWidth}px`;
    this.thumbnailHeightWrapper = `${thumbnailWidth.clientWidth + 3}px`;
  }
}
